export default __webpack_public_path__ + "static/media/about-new.96da992f.png";